<template>
  <el-dialog title="获取二维码" :visible.sync="formVisible" width="350px">
    <el-col :span="24" style="margin-bottom: 20px;">
      <div style="text-align: center;">
        <el-select v-model="showmods" placeholder="选择方式" class="sels">
          <el-option label="网页H5" value="h5" />
          <el-option label="微信小程序" value="xcx" />
        </el-select>
      </div>
      <div v-show="showmods == 'h5'">
        <div class="qrtits">
          网页通用:
          <el-tooltip class="item" effect="dark" content="微信 扫一扫" placement="top">
            <img src="//static.jazpan.com/img/weixinlg.png" />
          </el-tooltip> &nbsp;
          <el-tooltip class="item" effect="dark" content="抖音 扫一扫" placement="top">
            <img src="//static.jazpan.com/img/douyin.png" />
          </el-tooltip> &nbsp;
          <el-tooltip class="item" effect="dark" content="支付宝 扫一扫" placement="top">
            <img src="//static.jazpan.com/img/alipayx.png" />
          </el-tooltip> &nbsp;
          <el-tooltip class="item" effect="dark" content="今日头条 扫一扫" placement="top">
            <img src="//static.jazpan.com/img/jrtt.png" />
          </el-tooltip>
        </div>
        <div ref="qrCodeDiv" class="qrcodeDiv"></div>
      </div>
      <div v-show="showmods == 'xcx'">
        <div class="qrtits">微信小程序</div>
        <div ref="qrCodeDivx" class="qrcodeDiv"></div>
      </div>

      <!-- <div class="checks"><el-checkbox v-model="shuiying" @change="syChange">有水印</el-checkbox></div> -->
      <div class="tips" v-if="showtips == true">温馨提示: 文件二维码有可能会失效, 但是文件夹二维码永远不会失效, 还能随时增减文件噢 !!!</div>
    </el-col>
    <!--工具条-->
    <div slot="footer" class="dialog-footer">
      <el-button @click.native="formVisible = false">完成</el-button>
    </div>
  </el-dialog>
</template>


<script>
// import QRCode from 'qrcodejs2';
export default {
  props: ["showtips"],
  data() {
    return {
      formVisible: false,
      shuiying: false,
      conts: '',
      conts2: '',
      showmods: 'h5',
    }
  },
  methods: {
    show(cont1, cont2) {
      if (!cont1 || cont1 == '') return;
      this.formVisible = true;
      this.shuiying = false;
      this.conts = cont1;
      this.conts2 = cont2;
      this.upQrCode();
    }, upQrCode() {
      if (!this.$refs.qrCodeDiv) {
        setTimeout(() => {
          this.upQrCode();
        }, 100);
        return;
      }
      const mrgs = (this.shuiying ? 100 : 50) + 'px';
      console.log('---shuiying:', this.shuiying, mrgs);
      this.$refs.qrCodeDiv.innerHTML = '';
      this.$refs.qrCodeDivx.innerHTML = '';
      new QRCode(this.$refs.qrCodeDiv, {
        text: this.conts,
        width: 200,
        height: 200,
        margin: mrgs,
      });
      new QRCode(this.$refs.qrCodeDivx, {
        text: this.conts2,
        width: 200,
        height: 200,
        margin: mrgs,
      });
    }, syChange() {
      this.upQrCode();
    }
  }
};

</script>

<style>
.qrcodeDiv {
  text-align: center;
}

.qrcodeDiv img {
  margin: auto;
}
</style>
<style scoped>
.tmpdesc {
  margin-left: 10px;
  color: #d0d0d0;
}

.sels {
  text-align: center;
  font-weight: bold;
  color: #194fe4;
  margin-bottom: 20px;
}

.qrtits {
  text-align: center;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #194fe4;
}

.qrtits img {
  width: 20px;
  height: 20px;
}


.tips {
  font-size: 14px;
  margin-top: 20px;
  color: #f60;
}

.checks {
  text-align: center;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// Qrcode.vue?93149250